/**
 * ToS acceptance carried as GoTrue signup metadata (RFC-1457).
 *
 * These keys land in `auth.users.raw_user_meta_data`, where the
 * `record_terms_acceptance` trigger (migration 106) reads them and writes the
 * audit row inside the same INSERT that creates the user — atomic, keyed to the
 * real account id, and impossible to lose to a dropped request or a closed tab.
 *
 * This is the ONLY way an acceptance is recorded. There is deliberately no API
 * endpoint: email sign-up is the only account-creation path that actually
 * works, and it can put the acceptance inside the INSERT. See the "OAuth" note
 * in the RFC for what would be needed if the OAuth buttons are ever wired up.
 */
import { getDeviceId } from '../../consent/consentStorage'
import { META_PRIVACY_URL, META_TERMS_URL, TERMS_POLICY_VERSION } from '../../constants/legal'

export function termsAcceptanceSignupMetadata(): Record<string, string> {
  const metadata: Record<string, string> = {
    terms_policy_version: TERMS_POLICY_VERSION,
    terms_url: META_TERMS_URL,
    privacy_url: META_PRIVACY_URL,
  }
  // The device id is a correlation aid, not part of the acceptance. It reads
  // localStorage, which can throw outright under hardened privacy settings —
  // and this runs synchronously on the signup submit path, so letting that
  // escape would fail the sign-up itself. Losing the id costs a join; losing
  // the sign-up costs the user their account.
  try {
    metadata.terms_device_id = getDeviceId()
  } catch {
    /* correlation only */
  }
  return metadata
}
